import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { json2csv } from 'json-2-csv';

export default class Widgets extends Component {
  static propTypes = {
    colorScheme: PropTypes.func,
    data: PropTypes.array,
    title: PropTypes.string,
    className: PropTypes.string,
    infoItems: PropTypes.array,
    height: PropTypes.num,
    width: PropTypes.num,
    onZoom: PropTypes.func,
    // zoomed: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      extraFilters: {}
    }
  }

  onAreaClick = (d, i) => this.setState({clickedAreaData: {data: d, key: Object.keys(this.props.data[0])[i]}})

  downloadDataAsCSV = () => {
    if(this.props.graph || this.props.exportData);
      const exportData = this.props.exportData ? this.props.exportData : this.props.graph;
      return json2csv(exportData, (err, csv) => {
        var element = document.createElement("a");
        var file = new Blob([csv], { type: "text/csv" });
        element.href = URL.createObjectURL(file);
        element.download = `${this.props.title || 'download'}.csv`;
        element.click();
      })
  }

  render() {
    return (<div>widget</div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Widgets/Widgets.js